   import React, { useEffect, useState } from 'react';
import '../styles/Admission.css';

const AdmissionPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="sgb-admission-wrapper">
      {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Admission</h1>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <main className="sgb-main-content-area">
        {/* About Section */}
        <section className={`sgb-info-card ${isVisible ? 'sgb-fade-in sgb-delay-1' : ''}`}>
          <h2 className="sgb-card-heading">About Admission</h2>
          <p className="sgb-paragraph-text">
            Seth. G.L Bihani S.D Sc.Sec. School is a non-profit organization and believes that education is a mission, not an occupation. It provides admission to the students with a view of better education on the minimum investment so as to promote education to all sections of society irrespective of creed, caste, race and religion.
          </p>
          <p className="sgb-paragraph-text"><strong>Junior:</strong> Class Nursery to VIII</p>
          <p className="sgb-paragraph-text"><strong>Senior:</strong> Class IX to XII (Science, Arts, Commerce & Agriculture)</p>
        </section>

        {/* Documents Section */}
        <section className={`sgb-info-card ${isVisible ? 'sgb-fade-in sgb-delay-2' : ''}`}>
          <h2 className="sgb-card-heading">Documents Required</h2>
          <ul className="sgb-requirement-list">
            <li>Two Passport Size Color Photographs</li>
            <li>Original Transfer Certificate from Previous School</li>
            <li>Attested Copy of Date of Birth Certificate</li>
            <li>Attested Photocopy of Mark Sheet of Previous Year</li>
            <li>Photocopy of Aadhar Card & Photocopy of Residence Proof</li>
            <li>Photocopy of SC/ST/OBC Certificate</li>
          </ul>
        </section>

        {/* Fee Section */}
        <section className={`sgb-info-card ${isVisible ? 'sgb-fade-in sgb-delay-3' : ''}`}>
          <h2 className="sgb-card-heading">Fee Details</h2>
          <div className="sgb-fee-details-box">
            <p className="sgb-fee-main-text">School Fee Will be payable in three Installments</p>
            <ul className="sgb-requirement-list">
              <li>First Installment will have to be deposited at the time of admission</li>
              <li>Second Installment will have to be deposited at the time of Second Test</li>
              <li>Third Installment will have to be deposited at the time of half Yearly Exam</li>
              <li>The Fee will have to be deposited in the school office and a receipt will be obtained. Keep receipt till end of the session</li>
            </ul>
          </div>
        </section>

        {/* Scholarships Section */}
        <section className={`sgb-info-card ${isVisible ? 'sgb-fade-in sgb-delay-4' : ''}`}>
          <h2 className="sgb-card-heading">Scholarships</h2>
          
          <h3 className="sgb-sub-heading">Government Scholarships</h3>
          <ul className="sgb-requirement-list">
            <li>Pre Metric Scholarship [Class 1 To 10]</li>
            <li>Post Metric Scholarship [Class 11 & 12]</li>
            <li>Pre Metric Minority Scholarship</li>
            <li>Post Metric Minority Scholarship</li>
            <li>Palanhaar Scheme Scholarship</li>
            <li>Gargi Prize</li>
            <li>Kalibai Bheel Scheme Scholarship</li>
            <li>Inspired Award</li>
          </ul>

          <h3 className="sgb-sub-heading">School Scholarships (10th Board Results)</h3>
          <div className="sgb-table-wrapper">
            <table className="sgb-scholarship-table">
              <thead>
                <tr>
                  <th>Marks Obtained</th>
                  <th>Scholarship</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>75 to 79.99</td>
                  <td>2,000 Rs</td>
                </tr>
                <tr>
                  <td>80 to 84.99</td>
                  <td>4,000 Rs</td>
                </tr>
                <tr>
                  <td>85 To 89.99</td>
                  <td>6,000 Rs</td>
                </tr>
                <tr>
                  <td>Above 90</td>
                  <td>7,500 Rs</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="sgb-notice-text">
            Secondary education board Rajasthan Ajmer will give a scholarship of Rs 21,000 For first position, Rs 11,000 For second position and Rs 5,100 For third Position in merit list of class 10 and 12
          </p>
        </section>

        {/* Sports Scholarships */}
        <section className={`sgb-info-card ${isVisible ? 'sgb-fade-in sgb-delay-5' : ''}`}>
          <h2 className="sgb-card-heading">Sports Scholarships</h2>
          <ul className="sgb-requirement-list">
            <li>If Team/Player comes first at the district level then its 4 Months fee will be waived. Similarly if the team and player remain runner-up at the district level then its 3 months fee will be waived</li>
            <li>If Team / Player is selected at the State level then its 6 Months fees will be waived. Similarly if Team / Player is selected at the National level or comes first, Second, Third Position From the State then its full fees will be waived</li>
          </ul>
        </section>

        {/* Contact Section */}
        <section className={`sgb-contact-card ${isVisible ? 'sgb-fade-in sgb-delay-6' : ''}`}>
          <h3>Have Any Questions?</h3>
          <p>Call Us / WhatsApp: 94600-26570</p>
          <a href='/contact' className="sgb-contact-button">Get In Touch</a>
        </section>
      </main>
    </div>
  );
};

export default AdmissionPage;